<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="12"
        md="12"
        sm="12"
      >
        <h2>Webメディア登録</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="*CD"
          v-model="item.cd"
          :error-messages="validation_errors.cd"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="*Webメディア名"
          v-model="item.name"
          :error-messages="validation_errors.name"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="6"
        sm="6"
      >
        <v-text-field
          label="ロゴのパス"
          v-model="item.logo_static_path"
          :error-messages="validation_errors.logo_static_path"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="6"
        sm="6"
      >
        <v-text-field
          label="URL"
          v-model="item.url"
          :error-messages="validation_errors.url"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="6"
        sm="6"
      >
        <v-text-field
          label="商品URL"
          v-model="item.promotion_url"
          :error-messages="validation_errors.promotion_url"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
        sm="8"
      >
        <v-text-field
          label="最終更新者"
          v-model="item.updated_by"
          readonly
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
        sm="6"
      >
        <v-text-field
          label="最終更新日"
          v-model="item.updated_at"
          readonly
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="2"
        sm="6"
      ><v-btn class="red white--text" @click="save">保存する</v-btn></v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      title: '',
      item: {},
      validation_errors: {},
    };
  },
  created() {
    if (this.$attrs.isCreate) {
      this.title = "Webメディア新規登録";
    } else {
      this.title = "Webメディア編集";
      this.getItem();
    }
  },
  methods: {
    async getItem() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/webmedia/${this.$route.params.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.item = response.data;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得に失敗しました", type: "error"});
        this.$router.push({name: 'WebMediaList'}).catch(()=>{});
      }
    },
    async save() {
      if (this.$attrs.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    async create() {
      try {
        const response = await this.$axios.post(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/webmedia/`,
          this.item,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.item = response.data
        this.validation_errors = {};
        this.$store.dispatch('setSnackbar', {message: "登録されました", type: "success"});
        this.$router.push({'name': 'EditWebMedia', 'params': {id: this.item.id}});
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "登録できませんでした", type: "error"});
        this.validation_errors = error.response.data;
      }
    },
    async update() {
      try {
        const response = await this.$axios.put(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/webmedia/${this.$route.params.id}/`,
          this.item,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        )
        this.item = response.data
        this.validation_errors = {};
        this.$store.dispatch('setSnackbar', {message: "保存されました", type: "success"});
        await this.getItem();
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "更新できませんでした", type: "error"});
        this.validation_errors = error.response.data;
      }
    },
  }
}
</script>